<template>
  <v-app>
    <v-container class="h-100">
      <v-row class="loader-container">
        <v-icon
          color="orange darken-1"
          class="pb-4"
          :size="$vuetify.breakpoint.lgAndUp ? 48 : 36"
          >mdi-alert-octagon-outline</v-icon
        >
        <h6 class="font-weight-bold pb-1">Tu sesión ha finalizado</h6>
        <p class="text-subtitle-1 text-center mb-0 custom-text">
          Ingresá con tu usuario y contraseña para acceder a la
          <span class="break-desktop"> plataforma. </span>
        </p>

        <v-btn
          color="blue darken-2 white--text"
          class="font-weight-black"
          large
          elevation="0"
          @click="clearSession"
        >
          iniciar sesión
        </v-btn>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "LoginError",
  methods: {
    ...mapActions({
      clearSession: "clearSession",
    }),
  },
};
</script>

<style scoped>
.loader-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0px 28px;
}
.custom-text {
  padding-bottom: 32px;
  opacity: 0.6;
}

h6 {
  font-size: 16px;
}

@media (min-width: 1264px) {
  h6 {
    font-size: 20px;
  }
  .loader-container {
    margin: 0px;
  }

  .custom-text {
    padding-bottom: 48px;
  }

  .break-desktop {
    display: block;
  }
}
</style>
